export default __webpack_public_path__ + "static/footer-logo-52cde6a13ea3cd60292f44e119ede6dd.svg";